import { AllCompaniesThemeSizeConfig } from './types';

const medium: AllCompaniesThemeSizeConfig = {
  allCompanies: {},
};

export default medium;
